import _ from "lodash";
import React from "react";
import { View } from "react-native";
import { sharedState } from "@core/SharedState";
import { BookshelfBookButton } from "../Component/BookshelfBookButton";
import { DraggableCollectionItem } from "./DraggableCollectionItem";
import { DraggingData } from "./DraggingItem";
import { DraggableData } from "./DragHandler";

export class DraggableCollectionBookData implements DraggableData {
  id: string;
  title: string;
  url: string;
  type: "ilks" | "other";
  thumbnailUrl?: string;
  typeName = "book";
  constructor(id: string, title: string, url: string, type: "ilks" | "other", thumbnailUrl?: string) {
    this.id = id;
    this.title = title;
    this.url = url;
    this.type = type;
    this.thumbnailUrl = thumbnailUrl;
  }

  renderDragging(): JSX.Element {
    return <DraggableCollectionBook key={"dragging" + this.id} data={this}></DraggableCollectionBook>;
  }
}

export class DraggableCollectionBook extends DraggableCollectionItem {
  @sharedState bookshelfScale = 1.0;

  onTap(): void {
    if (this.isFloating || this.isSelected) {
      return;
    }

    if (this.draggingData && this.draggingData.data.every((v) => v.typeName !== "bookshelf")) {
      this.draggingData.data.push(this.props.data);
      this.draggingData = _.clone(this.draggingData);
    } else {
      this.currentScene?.navigation.navigate("BookSummary", {
        title: this.draggableData.title,
        url: this.draggableData.url,
        type: this.draggableData.type,
      });
    }
  }

  drop(draggingData: DraggingData): void {
    if (!this.props.parent) {
      return;
    }
    this.props.parent?.drop(draggingData);
  }

  get draggableData(): DraggableCollectionBookData {
    return this.props.data as DraggableCollectionBookData;
  }

  renderItem(): JSX.Element {
    let color: string | undefined = undefined;
    let opacity: number | undefined = undefined;
    if (this.isFloating) {
      color = "yellow";
      opacity = 1;
    } else if (this.into) {
      color = "red";
      opacity = 1;
    } else if (this.hover) {
      color = "magenta";
      opacity = 1;
    }
    if (this.touching) {
      color = "white";
      opacity = 0.2;
    }
    if (this.holding) {
      color = "white";
      opacity = 0.8;
    }

    return (
      <View style={{ marginBottom: 35 * this.bookshelfScale }}>
        <BookshelfBookButton
          title={this.draggableData.title}
          type="book"
          thumbnailUrl={this.draggableData.thumbnailUrl}
          authorName={"作者名"}
          genre={"ジャンル"}
          style={color ? { backgroundColor: color, opacity: opacity } : {}}
          onPress={() => {
            // this.currentScene?.navigation.navigate("BookSummary", {
            //   id: this.props.data.id,
            //   title: this.props.data.title,
            //   url: this.props.data.url,
            //   type: this.props.data.type,
            // });
          }}
        ></BookshelfBookButton>
      </View>
    );
  }
}
